module.exports = __webpack_public_path__ + "static/media/order.b9823fac.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/order.mp3
// module id = 55
// module chunks = 28